var e={emptyStateWrapper:"rl2_emptyState-module_emptyStateWrapper_tFOS-",headline:"rl2_emptyState-module_headline_3Ev7K",subhead:"rl2_emptyState-module_subhead_NHgGV"};export{e as default};
